<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="containersSelected"
    :clearable="!unclearable"
    :items="containersCategoryItems"
    :loading="containersLoading"
    :search-input.sync="containersSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('ContainerCategories.title')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import ContainerCategories from "@/api/container_categories";

export default {
  name: "SearcherContainerCategories",

  props: {
    value: Object,
    noLabel: Boolean,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    containersCategoryItems() {
      return this.containerCategories.map((c) => {
        const Description = c.category_name;
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == c.id)
          : false;
        return Object.assign({}, c, { Description, disabled });
      });
    },
  },

  data: () => ({
    containerCategories: [],
    containersLoading: false,
    containersSearch: "",
    containersSelected: null,
  }),

  methods: {
    getContainersFromAPI() {
      this.containersLoading = true;
      ContainerCategories.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.containerCategories = response.data.container_categories;
            }
            this.containersLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.containersLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.containersSelected = this.value;
      },
    },
    containersSelected: {
      handler() {
        this.$emit("input", this.containersSelected);
      },
    },
    containersSearch: {
      immediate: true, //初始赋值也调用
      handler() {
        if (
          this.containersSelected &&
          this.containersSearch ==
            this.containersSelected.shop_code +
              " / " +
              this.containersSelected.shop_name
        )
          return; // 查询结果一致的话不再执行

        this.getContainersFromAPI();
      },
    },
  },
};
</script>